import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './image-full-with-text.component.scss';
var ImageFullWithText = /** @class */ (function (_super) {
    tslib_1.__extends(ImageFullWithText, _super);
    function ImageFullWithText(element) {
        return _super.call(this, element) || this;
    }
    ImageFullWithText.prototype.init = function () {
    };
    ImageFullWithText.prototype.bindEvents = function () {
    };
    return ImageFullWithText;
}(Base));
export { ImageFullWithText };



//////////////////
// WEBPACK FOOTER
// ./components/image-full-with-text/image-full-with-text.component.ts
// module id = 371
// module chunks = 0